import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const badgeDefaultVariants = {
  "type": "outline",
  "color": "accent"
}
const badgeCompoundVariants = [
  {
    "type": "tint",
    "color": "accent",
    "css": {
      "root": {
        "--badge-background-color": "colors.background.accent.primary.tint",
        "--badge-color": "colors.content.accent.info"
      }
    }
  },
  {
    "type": "outline",
    "color": "accent",
    "css": {
      "root": {
        "--badge-border-color": "colors.border.accent.info",
        "--badge-color": "colors.content.accent.info"
      }
    }
  },
  {
    "type": "tint",
    "color": "neutral",
    "css": {
      "root": {
        "--badge-background-color": "colors.background.accent.secondary.tint",
        "--badge-color": "colors.content.default.level-3"
      }
    }
  },
  {
    "type": "outline",
    "color": "neutral",
    "css": {
      "root": {
        "--badge-border-color": "colors.border.default.level-2",
        "--badge-color": "colors.content.default.level-3"
      }
    }
  },
  {
    "type": "tint",
    "color": "positive",
    "css": {
      "root": {
        "--badge-background-color": "colors.background.state.positive.tint",
        "--badge-color": "colors.content.state.positive"
      }
    }
  },
  {
    "type": "outline",
    "color": "positive",
    "css": {
      "root": {
        "--badge-border-color": "colors.border.state.positive",
        "--badge-color": "colors.content.state.positive"
      }
    }
  },
  {
    "type": "tint",
    "color": "buy",
    "css": {
      "root": {
        "--badge-background-color": "colors.background.accent.buy.tint",
        "--badge-color": "colors.content.accent.buy"
      }
    }
  },
  {
    "type": "outline",
    "color": "buy",
    "css": {
      "root": {
        "--badge-border-color": "colors.border.accent.buy",
        "--badge-color": "colors.content.accent.buy"
      }
    }
  },
  {
    "type": "tint",
    "color": "negative",
    "css": {
      "root": {
        "--badge-background-color": "colors.background.state.negative.tint",
        "--badge-color": "colors.content.state.negative"
      }
    }
  },
  {
    "type": "outline",
    "color": "negative",
    "css": {
      "root": {
        "--badge-border-color": "colors.border.state.negative",
        "--badge-color": "colors.content.state.negative"
      }
    }
  },
  {
    "type": "tint",
    "color": "new",
    "css": {
      "root": {
        "--badge-background-color": "colors.background.accent.new.tint",
        "--badge-color": "colors.content.accent.new"
      }
    }
  },
  {
    "type": "outline",
    "color": "new",
    "css": {
      "root": {
        "--badge-border-color": "colors.border.accent.new",
        "--badge-color": "colors.content.accent.new"
      }
    }
  },
  {
    "type": "tint",
    "color": "sell",
    "css": {
      "root": {
        "--badge-background-color": "colors.background.accent.sell.tint",
        "--badge-color": "colors.content.accent.sell"
      }
    }
  },
  {
    "type": "outline",
    "color": "sell",
    "css": {
      "root": {
        "--badge-border-color": "colors.border.accent.sell",
        "--badge-color": "colors.content.accent.sell"
      }
    }
  },
  {
    "type": "tint",
    "color": "warning",
    "css": {
      "root": {
        "--badge-background-color": "colors.background.state.warning.tint",
        "--badge-color": "colors.content.state.warning"
      }
    }
  },
  {
    "type": "outline",
    "color": "warning",
    "css": {
      "root": {
        "--badge-border-color": "colors.border.state.warning",
        "--badge-color": "colors.content.state.warning"
      }
    }
  },
  {
    "type": "tint",
    "color": "promotion",
    "css": {
      "root": {
        "--badge-background-color": "colors.background.accent.promotion.tint",
        "--badge-color": "colors.content.accent.promotion"
      }
    }
  },
  {
    "type": "outline",
    "color": "promotion",
    "css": {
      "root": {
        "--badge-border-color": "colors.border.accent.promotion",
        "--badge-color": "colors.content.accent.promotion"
      }
    }
  }
]

const badgeSlotNames = [
  [
    "root",
    "badge__root"
  ],
  [
    "icon",
    "badge__icon"
  ]
]
const badgeSlotFns = /* @__PURE__ */ badgeSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, badgeDefaultVariants, getSlotCompoundVariant(badgeCompoundVariants, slotName))])

const badgeFn = memo((props = {}) => {
  return Object.fromEntries(badgeSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const badgeVariantKeys = [
  "type",
  "color"
]
const getVariantProps = (variants) => ({ ...badgeDefaultVariants, ...compact(variants) })

export const badge = /* @__PURE__ */ Object.assign(badgeFn, {
  __recipe__: false,
  __name__: 'badge',
  raw: (props) => props,
  variantKeys: badgeVariantKeys,
  variantMap: {
  "type": [
    "tint",
    "outline"
  ],
  "color": [
    "accent",
    "neutral",
    "positive",
    "buy",
    "negative",
    "sell",
    "new",
    "warning",
    "promotion"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, badgeVariantKeys)
  },
  getVariantProps
})